import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogTundish } from "../../../models/CatalogTundish";

type Props = {
  setTundish: (tundish: CatalogTundish) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewTundish: () => void;
};

export const useTundishOptionsFunctions = ({
  setTundish,
  setShowModal,
  handleNewTundish,
}: Props) => {
  const getMenuOptions = (data: CatalogTundish) => {
    let options: MenuOptionType[] = [
      {
        name: "New Tundish",
        key: "new_tundish",
        onClick: () => {
          handleNewTundish();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Tundish",
          key: "edit_tundish",
          onClick: () => {
            setTundish(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Tundish",
          key: "delete_tundish",
          onClick: () => {
            setTundish(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
